var items = {
  "block.minecraft.air": "vazduh",
  "block.minecraft.stone": "kamen",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "polirani granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "polirani diorit",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "polirani andezit",
  "block.minecraft.grass_block": "blok trave",
  "block.minecraft.dirt": "zemlja",
  "block.minecraft.coarse_dirt": "gruba zemlja",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "grimizni nilijum",
  "block.minecraft.warped_nylium": "izopačeni nilijum",
  "block.minecraft.cobblestone": "blok kaldrme",
  "block.minecraft.oak_planks": "daska od hrasta",
  "block.minecraft.spruce_planks": "daska od smreke",
  "block.minecraft.birch_planks": "daska od breze",
  "block.minecraft.jungle_planks": "daska od džungle",
  "block.minecraft.acacia_planks": "daska od bagrema",
  "block.minecraft.dark_oak_planks": "daska od tamnog hrasta",
  "block.minecraft.crimson_planks": "grimizne daske",
  "block.minecraft.warped_planks": "izopačene daske",
  "block.minecraft.oak_sapling": "sadnica od hrasta",
  "block.minecraft.spruce_sapling": "sadnica smreke",
  "block.minecraft.birch_sapling": "sadnica breze",
  "block.minecraft.jungle_sapling": "sadnica džungle",
  "block.minecraft.acacia_sapling": "sadnica bagrema",
  "block.minecraft.dark_oak_sapling": "sadnica od tamnog hrasta",
  "block.minecraft.bedrock": "temelj",
  "block.minecraft.sand": "pijesak",
  "block.minecraft.red_sand": "crveni pijesak",
  "block.minecraft.gravel": "šljunak",
  "block.minecraft.gold_ore": "ruda zlata",
  "block.minecraft.iron_ore": "ruda gvožđa",
  "block.minecraft.coal_ore": "ruda uglja",
  "block.minecraft.nether_gold_ore": "paklena zlatna ruda",
  "block.minecraft.oak_log": "hrastov panj",
  "block.minecraft.spruce_log": "smrekin panj",
  "block.minecraft.birch_log": "brezin panj",
  "block.minecraft.jungle_log": "džunglin panj",
  "block.minecraft.acacia_log": "bagremov panj",
  "block.minecraft.dark_oak_log": "tamni hrastov panj",
  "block.minecraft.crimson_stem": "grimizna stabljika",
  "block.minecraft.warped_stem": "izopačeno stablo",
  "block.minecraft.stripped_oak_log": "oguljen panj od hrasta",
  "block.minecraft.stripped_spruce_log": "oguljen panj od smreke",
  "block.minecraft.stripped_birch_log": "oguljen panj od breze",
  "block.minecraft.stripped_jungle_log": "oguljen panj od džungle",
  "block.minecraft.stripped_acacia_log": "oguljen panj od bagrema",
  "block.minecraft.stripped_dark_oak_log": "oguljen panj od tamnog hrasta",
  "block.minecraft.stripped_crimson_stem": "oguljeno grimizno stablo",
  "block.minecraft.stripped_warped_stem": "oguljeno izopačeno stablo",
  "block.minecraft.stripped_oak_wood": "oguljeno hrastovo drvo",
  "block.minecraft.stripped_spruce_wood": "oguljeno smrekino drvo",
  "block.minecraft.stripped_birch_wood": "oguljeno brezino drvo",
  "block.minecraft.stripped_jungle_wood": "oguljeno džunglino drvo",
  "block.minecraft.stripped_acacia_wood": "oguljeno bagremovo drvo",
  "block.minecraft.stripped_dark_oak_wood": "oguljeno tamno hrastovo drvo",
  "block.minecraft.stripped_crimson_hyphae": "oguljene grimizne hife",
  "block.minecraft.stripped_warped_hyphae": "oguljene grimizne hife",
  "block.minecraft.oak_wood": "drvo hrasta",
  "block.minecraft.spruce_wood": "drvo smreke",
  "block.minecraft.birch_wood": "drvo breze",
  "block.minecraft.jungle_wood": "drvo džungle",
  "block.minecraft.acacia_wood": "drvo bagrema",
  "block.minecraft.dark_oak_wood": "drvo tamnog hrasta",
  "block.minecraft.crimson_hyphae": "grimizne hife",
  "block.minecraft.warped_hyphae": "izopačene hife",
  "block.minecraft.oak_leaves": "lišće hrasta",
  "block.minecraft.spruce_leaves": "lišće smreke",
  "block.minecraft.birch_leaves": "list breze",
  "block.minecraft.jungle_leaves": "list džungle",
  "block.minecraft.acacia_leaves": "lišće bagrema",
  "block.minecraft.dark_oak_leaves": "list tamnog hrasta",
  "block.minecraft.sponge": "spužva",
  "block.minecraft.wet_sponge": "mokra spužva",
  "block.minecraft.glass": "staklo",
  "block.minecraft.lapis_ore": "ruda lapiza",
  "block.minecraft.lapis_block": "blok lapiza",
  "block.minecraft.dispenser": "automat",
  "block.minecraft.sandstone": "pješčani kamen",
  "block.minecraft.chiseled_sandstone": "klesani pješčani kamen",
  "block.minecraft.cut_sandstone": "izrezani pješčani kamen",
  "block.minecraft.note_block": "blok nota",
  "block.minecraft.powered_rail": "pruga s pogonom",
  "block.minecraft.detector_rail": "pruga s detektorom",
  "block.minecraft.sticky_piston": "ljepljivi izbacivač",
  "block.minecraft.cobweb": "mreža",
  "block.minecraft.grass": "trava",
  "block.minecraft.fern": "paprat",
  "block.minecraft.dead_bush": "mrtvi grm",
  "block.minecraft.seagrass": "morska trava",
  "block.minecraft.sea_pickle": "morski krastavac",
  "block.minecraft.piston": "izbacivač",
  "block.minecraft.white_wool": "bijela vuna",
  "block.minecraft.orange_wool": "narandžasta vuna",
  "block.minecraft.magenta_wool": "purpurcrvena vuna",
  "block.minecraft.light_blue_wool": "svijetlo plava vuna",
  "block.minecraft.yellow_wool": "žuta vuna",
  "block.minecraft.lime_wool": "svijetlo zelena vuna",
  "block.minecraft.pink_wool": "roze vuna",
  "block.minecraft.gray_wool": "siva vuna",
  "block.minecraft.light_gray_wool": "svijetlo siva vuna",
  "block.minecraft.cyan_wool": "cijan vuna",
  "block.minecraft.purple_wool": "ljubičasta vuna",
  "block.minecraft.blue_wool": "plava vuna",
  "block.minecraft.brown_wool": "braon vuna",
  "block.minecraft.green_wool": "zelena vuna",
  "block.minecraft.red_wool": "crvena vuna",
  "block.minecraft.black_wool": "crna vuna",
  "block.minecraft.dandelion": "maslačak",
  "block.minecraft.poppy": "mak",
  "block.minecraft.blue_orchid": "plava orhideja",
  "block.minecraft.allium": "ukrasni luk",
  "block.minecraft.azure_bluet": "plava maćuhica",
  "block.minecraft.red_tulip": "crveni tulipan",
  "block.minecraft.orange_tulip": "narandžasti tulipan",
  "block.minecraft.white_tulip": "bijeli tulipan",
  "block.minecraft.pink_tulip": "rozi tulipan",
  "block.minecraft.oxeye_daisy": "tratinčica",
  "block.minecraft.cornflower": "različak",
  "block.minecraft.lily_of_the_valley": "đurđevak",
  "block.minecraft.wither_rose": "vider ruža",
  "block.minecraft.brown_mushroom": "braon pečurka",
  "block.minecraft.red_mushroom": "crvena pečurka",
  "block.minecraft.crimson_fungus": "grimizna gljiva",
  "block.minecraft.warped_fungus": "luda gljiva",
  "block.minecraft.crimson_roots": "grimizno korijenje",
  "block.minecraft.warped_roots": "izopačeno korijenje",
  "block.minecraft.nether_sprouts": "neder klice",
  "block.minecraft.weeping_vines": "žalosne lijane",
  "block.minecraft.twisting_vines": "uvrnute lijane",
  "block.minecraft.sugar_cane": "šećerna trska",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "blok zlata",
  "block.minecraft.iron_block": "blok gvožđa",
  "block.minecraft.oak_slab": "ploča od hrasta",
  "block.minecraft.spruce_slab": "ploča od smreke",
  "block.minecraft.birch_slab": "ploča od breze",
  "block.minecraft.jungle_slab": "ploča od džungle",
  "block.minecraft.acacia_slab": "ploča od bagrema",
  "block.minecraft.dark_oak_slab": "ploča od tamnog hrasta",
  "block.minecraft.crimson_slab": "grimizna ploča",
  "block.minecraft.warped_slab": "izopačena ploča",
  "block.minecraft.stone_slab": "kamena ploča",
  "block.minecraft.smooth_stone_slab": "glatki kameni prag",
  "block.minecraft.sandstone_slab": "ploča pješčanog kamena",
  "block.minecraft.cut_sandstone_slab": "ploča isječenog pješčanog kamena",
  "block.minecraft.petrified_oak_slab": "petrifikovana ploča od hrasta",
  "block.minecraft.cobblestone_slab": "kamena ploča",
  "block.minecraft.brick_slab": "ploča od cigle",
  "block.minecraft.stone_brick_slab": "ploča od kamene cigle",
  "block.minecraft.nether_brick_slab": "ploča nederske cigle",
  "block.minecraft.quartz_slab": "kvarcna ploča",
  "block.minecraft.red_sandstone_slab": "ploča crvenog pješčanog kamena",
  "block.minecraft.cut_red_sandstone_slab": "ploča isječenog crvenog pješčanog kamena",
  "block.minecraft.purpur_slab": "ploča purpura",
  "block.minecraft.prismarine_slab": "ploča od prizmarina",
  "block.minecraft.prismarine_brick_slab": "prizmarinsko  ciglasta ploča",
  "block.minecraft.dark_prismarine_slab": "ploča od tamnog prizmarina",
  "block.minecraft.smooth_quartz": "glatki blok kvarca",
  "block.minecraft.smooth_red_sandstone": "glatki crveni pješčani kamen",
  "block.minecraft.smooth_sandstone": "glatki pješčani kamen",
  "block.minecraft.smooth_stone": "glatki kamen",
  "block.minecraft.bricks": "cigle",
  "block.minecraft.tnt": "dinamit",
  "block.minecraft.bookshelf": "polica za knjige",
  "block.minecraft.mossy_cobblestone": "mahovinasta kaldrma",
  "block.minecraft.obsidian": "obsidijan",
  "block.minecraft.torch": "baklja",
  "block.minecraft.end_rod": "end štap",
  "block.minecraft.chorus_plant": "horus",
  "block.minecraft.chorus_flower": "cvijet horusa",
  "block.minecraft.purpur_block": "blok purpura",
  "block.minecraft.purpur_pillar": "stub purpura",
  "block.minecraft.purpur_stairs": "stepenice purpura",
  "block.minecraft.spawner": "stvaratelj",
  "block.minecraft.oak_stairs": "stepenice od hrasta",
  "block.minecraft.chest": "kovčeg",
  "block.minecraft.diamond_ore": "ruda dijamanta",
  "block.minecraft.diamond_block": "blok dijamanta",
  "block.minecraft.crafting_table": "radni sto",
  "block.minecraft.farmland": "polje",
  "block.minecraft.furnace": "peć",
  "block.minecraft.ladder": "ljestve",
  "block.minecraft.rail": "pruga",
  "block.minecraft.cobblestone_stairs": "kamene stepenice",
  "block.minecraft.lever": "poluga",
  "block.minecraft.stone_pressure_plate": "kamena potisna ploča",
  "block.minecraft.oak_pressure_plate": "potisna ploča od hrasta",
  "block.minecraft.spruce_pressure_plate": "potisna ploča od smreke",
  "block.minecraft.birch_pressure_plate": "potisna ploča od breze",
  "block.minecraft.jungle_pressure_plate": "potisna ploča od džungle",
  "block.minecraft.acacia_pressure_plate": "potisna ploča od bagrema",
  "block.minecraft.dark_oak_pressure_plate": "potisna ploča od tamnog hrasta",
  "block.minecraft.crimson_pressure_plate": "grimizna nagazna ploča",
  "block.minecraft.warped_pressure_plate": "izopačena nagazna ploča",
  "block.minecraft.polished_blackstone_pressure_plate": "nagazna ploča od poliranog crnog kamena",
  "block.minecraft.redstone_ore": "ruda redstona",
  "block.minecraft.redstone_torch": "baklja redstona",
  "block.minecraft.snow": "snijeg",
  "block.minecraft.ice": "led",
  "block.minecraft.snow_block": "sniježni blok",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "glina",
  "block.minecraft.jukebox": "džuboks",
  "block.minecraft.oak_fence": "ograda od hrasta",
  "block.minecraft.spruce_fence": "smrekvina ograda",
  "block.minecraft.birch_fence": "brezina ograda",
  "block.minecraft.jungle_fence": "džunglina ograda",
  "block.minecraft.acacia_fence": "ograda od bagrema",
  "block.minecraft.dark_oak_fence": "ograda od tamnog hrasta",
  "block.minecraft.crimson_fence": "grimizna ograda",
  "block.minecraft.warped_fence": "izopačena ograda",
  "block.minecraft.pumpkin": "bundeva",
  "block.minecraft.carved_pumpkin": "izrezbarena bundeva",
  "block.minecraft.netherrack": "neder kamen",
  "block.minecraft.soul_sand": "živi pijesak",
  "block.minecraft.soul_soil": "duševna zemlja",
  "block.minecraft.basalt": "bazalt",
  "block.minecraft.polished_basalt": "polirani bazalt",
  "block.minecraft.soul_torch": "baklja duše",
  "block.minecraft.glowstone": "svijetleći kamen",
  "block.minecraft.jack_o_lantern": "svijetleća bundeva",
  "block.minecraft.oak_trapdoor": "poklopac od hrasta",
  "block.minecraft.spruce_trapdoor": "poklopac od smreke",
  "block.minecraft.birch_trapdoor": "poklopac od breze",
  "block.minecraft.jungle_trapdoor": "poklopac od džungle",
  "block.minecraft.acacia_trapdoor": "poklopac od bagrema",
  "block.minecraft.dark_oak_trapdoor": "poklopac od tamnog hrasta",
  "block.minecraft.crimson_trapdoor": "grimizna podna vrata",
  "block.minecraft.warped_trapdoor": "izopačena podna vrata",
  "block.minecraft.infested_stone": "opustošen kamen",
  "block.minecraft.infested_cobblestone": "opustošen kaldrmasti kamen",
  "block.minecraft.infested_stone_bricks": "opustošena kamena cigla",
  "block.minecraft.infested_mossy_stone_bricks": "opustošena mahovita kamena cigla",
  "block.minecraft.infested_cracked_stone_bricks": "opustošena napukla kamena cigla",
  "block.minecraft.infested_chiseled_stone_bricks": "opustošena izdubljena kamena cigla",
  "block.minecraft.stone_bricks": "kamene stepenice",
  "block.minecraft.mossy_stone_bricks": "obrasle kamene cigle",
  "block.minecraft.cracked_stone_bricks": "napukle kamene cigle",
  "block.minecraft.chiseled_stone_bricks": "klesane kamene cigle",
  "block.minecraft.brown_mushroom_block": "braon blok pečurki",
  "block.minecraft.red_mushroom_block": "crveni blok pečurki",
  "block.minecraft.mushroom_stem": "stabljika pečurke",
  "block.minecraft.iron_bars": "gvozdene šipke",
  "block.minecraft.chain": "lanac",
  "block.minecraft.glass_pane": "staklena ploča",
  "block.minecraft.melon": "lubenica",
  "block.minecraft.vine": "vinova loza",
  "block.minecraft.oak_fence_gate": "vrata za ogradu od hrasta",
  "block.minecraft.spruce_fence_gate": "smrekvina vrata za ogradu",
  "block.minecraft.birch_fence_gate": "brezina vrata za ogradu",
  "block.minecraft.jungle_fence_gate": "džunglina vrata za ogradu",
  "block.minecraft.acacia_fence_gate": "vrata za ogradu od bagrema",
  "block.minecraft.dark_oak_fence_gate": "vrata za ogradu od tamnog hrasta",
  "block.minecraft.crimson_fence_gate": "vrata za grimiznu ogradu",
  "block.minecraft.warped_fence_gate": "vrata za izopačenu ogradu",
  "block.minecraft.brick_stairs": "kamene stepenice",
  "block.minecraft.stone_brick_stairs": "stepenice od kamenih cigla",
  "block.minecraft.mycelium": "micelijum",
  "block.minecraft.lily_pad": "lokvanj",
  "block.minecraft.nether_bricks": "neder cigle",
  "block.minecraft.cracked_nether_bricks": "napukle podzemske cigle",
  "block.minecraft.chiseled_nether_bricks": "isklesane neder cigle",
  "block.minecraft.nether_brick_fence": "ograda nederskih cigla",
  "block.minecraft.nether_brick_stairs": "stepenice nederskih cigla",
  "block.minecraft.enchanting_table": "magični sto",
  "block.minecraft.end_portal_frame": "end protal ram",
  "block.minecraft.end_stone": "enderski kamen",
  "block.minecraft.end_stone_bricks": "end kamene cigle",
  "block.minecraft.dragon_egg": "zmajevo jaje",
  "block.minecraft.redstone_lamp": "redstone lampa",
  "block.minecraft.sandstone_stairs": "pješčane stepenice",
  "block.minecraft.emerald_ore": "ruda smaragda",
  "block.minecraft.ender_chest": "ender kovčeg",
  "block.minecraft.tripwire_hook": "kuka za nagaznu žicu",
  "block.minecraft.emerald_block": "blok smaragda",
  "block.minecraft.spruce_stairs": "stepenice od smreke",
  "block.minecraft.birch_stairs": "stepenice od breze",
  "block.minecraft.jungle_stairs": "stepenice od džungle",
  "block.minecraft.crimson_stairs": "grimizne stepenice",
  "block.minecraft.warped_stairs": "izopačene stepenice",
  "block.minecraft.command_block": "naredbeni blok",
  "block.minecraft.beacon": "svjetionik",
  "block.minecraft.cobblestone_wall": "kameni zid",
  "block.minecraft.mossy_cobblestone_wall": "zarasli kameni zid",
  "block.minecraft.brick_wall": "zid od cigla",
  "block.minecraft.prismarine_wall": "zid od prizmarina",
  "block.minecraft.red_sandstone_wall": "zid od crvenog pjeska",
  "block.minecraft.mossy_stone_brick_wall": "zid od obraslih kamenih cigla",
  "block.minecraft.granite_wall": "zid od granita",
  "block.minecraft.stone_brick_wall": "zid od kamene cigle",
  "block.minecraft.nether_brick_wall": "zid od nederske cigle",
  "block.minecraft.andesite_wall": "zid od andezita",
  "block.minecraft.red_nether_brick_wall": "zid od crvene neder cigle",
  "block.minecraft.sandstone_wall": "zid od crvenog pješčanog kamena",
  "block.minecraft.end_stone_brick_wall": "zid od kamene end cigle",
  "block.minecraft.diorite_wall": "zid od diorita",
  "block.minecraft.blackstone_wall": "zid od crnog kamena",
  "block.minecraft.polished_blackstone_wall": "zid od poliranog crnog kamena",
  "block.minecraft.polished_blackstone_brick_wall": "zid od cigli poliranog crnog kamena",
  "block.minecraft.stone_button": "kameno dugme",
  "block.minecraft.oak_button": "dugme od hrasta",
  "block.minecraft.spruce_button": "dugme od smreke",
  "block.minecraft.birch_button": "dugme od breze",
  "block.minecraft.jungle_button": "dugme od džungle",
  "block.minecraft.acacia_button": "dugme od bagrema",
  "block.minecraft.dark_oak_button": "dugme od tamnog hrasta",
  "block.minecraft.crimson_button": "grimizno dugme",
  "block.minecraft.warped_button": "izopačeno dugme",
  "block.minecraft.polished_blackstone_button": "dugme od poliranog crnog kamena",
  "block.minecraft.anvil": "nakovanj",
  "block.minecraft.chipped_anvil": "okrnjen nakovanj",
  "block.minecraft.damaged_anvil": "oštećeni nakovanj",
  "block.minecraft.trapped_chest": "kovčeg sa zamkom",
  "block.minecraft.light_weighted_pressure_plate": "lagana potisna ploča",
  "block.minecraft.heavy_weighted_pressure_plate": "teška otežana ploča",
  "block.minecraft.daylight_detector": "detektor dnevne svijetlosti",
  "block.minecraft.redstone_block": "blok redstona",
  "block.minecraft.nether_quartz_ore": "neder kvarcna ruda",
  "block.minecraft.hopper": "lijevak",
  "block.minecraft.chiseled_quartz_block": "isklesani blok kvarca",
  "block.minecraft.quartz_block": "blok kvarca",
  "block.minecraft.quartz_bricks": "kvarcne cigle",
  "block.minecraft.quartz_pillar": "kvarcni stub",
  "block.minecraft.quartz_stairs": "kvarcne stepenice",
  "block.minecraft.activator_rail": "pruga sa aktivatorom",
  "block.minecraft.dropper": "izbacivač",
  "block.minecraft.white_terracotta": "bijela terakota",
  "block.minecraft.orange_terracotta": "narandžasta terakota",
  "block.minecraft.magenta_terracotta": "purpurcrvena terakota",
  "block.minecraft.light_blue_terracotta": "svijetlo plava terakota",
  "block.minecraft.yellow_terracotta": "žuta terakota",
  "block.minecraft.lime_terracotta": "svijetlo zelena terakota",
  "block.minecraft.pink_terracotta": "roza terakota",
  "block.minecraft.gray_terracotta": "siva terakota",
  "block.minecraft.light_gray_terracotta": "svijetlo siva terakota",
  "block.minecraft.cyan_terracotta": "cijan terakota",
  "block.minecraft.purple_terracotta": "ljubičasta terakota",
  "block.minecraft.blue_terracotta": "plava terakota",
  "block.minecraft.brown_terracotta": "braon terakota",
  "block.minecraft.green_terracotta": "zelena terakota",
  "block.minecraft.red_terracotta": "crvena terakota",
  "block.minecraft.black_terracotta": "crna terakota",
  "block.minecraft.barrier": "barijera",
  "block.minecraft.iron_trapdoor": "gvozdeni poklopac",
  "block.minecraft.hay_block": "bala sijena",
  "block.minecraft.white_carpet": "bijeli tepih",
  "block.minecraft.orange_carpet": "narandžasti tepih",
  "block.minecraft.magenta_carpet": "purpurnocrveni tepih",
  "block.minecraft.light_blue_carpet": "svijetlo plavi tepih",
  "block.minecraft.yellow_carpet": "žuti tepih",
  "block.minecraft.lime_carpet": "svijetlo zeleni tepih",
  "block.minecraft.pink_carpet": "rozi tepih",
  "block.minecraft.gray_carpet": "sivi tepih",
  "block.minecraft.light_gray_carpet": "svijetlo sivi tepih",
  "block.minecraft.cyan_carpet": "cijan tepih",
  "block.minecraft.purple_carpet": "ljubičasti tepih",
  "block.minecraft.blue_carpet": "plavi tepih",
  "block.minecraft.brown_carpet": "braon tepih",
  "block.minecraft.green_carpet": "zeleni tepih",
  "block.minecraft.red_carpet": "crveni tepih",
  "block.minecraft.black_carpet": "crni tepih",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "blok uglja",
  "block.minecraft.packed_ice": "tvrdi led",
  "block.minecraft.acacia_stairs": "stepenice od bagrema",
  "block.minecraft.dark_oak_stairs": "stepenice od tamnog hrasta",
  "block.minecraft.slime_block": "ljigav blok",
  "block.minecraft.grass_path": "travnati put",
  "block.minecraft.sunflower": "suncokret",
  "block.minecraft.lilac": "jorgovan",
  "block.minecraft.rose_bush": "grm ruže",
  "block.minecraft.peony": "božur",
  "block.minecraft.tall_grass": "visoka trava",
  "block.minecraft.large_fern": "velika paprat",
  "block.minecraft.white_stained_glass": "bijelo staklo",
  "block.minecraft.orange_stained_glass": "narandžasto staklo",
  "block.minecraft.magenta_stained_glass": "purpurnocrveno staklo",
  "block.minecraft.light_blue_stained_glass": "svijetlo plavo staklo",
  "block.minecraft.yellow_stained_glass": "žuto staklo",
  "block.minecraft.lime_stained_glass": "svijetlo zeleno staklo",
  "block.minecraft.pink_stained_glass": "rozo staklo",
  "block.minecraft.gray_stained_glass": "sivo staklo",
  "block.minecraft.light_gray_stained_glass": "svijetlo sivo staklo",
  "block.minecraft.cyan_stained_glass": "cijan staklo",
  "block.minecraft.purple_stained_glass": "ljubičasto staklo",
  "block.minecraft.blue_stained_glass": "plavo staklo",
  "block.minecraft.brown_stained_glass": "braon staklo",
  "block.minecraft.green_stained_glass": "zeleno staklo",
  "block.minecraft.red_stained_glass": "crveno staklo",
  "block.minecraft.black_stained_glass": "crno staklo",
  "block.minecraft.white_stained_glass_pane": "bijela staklena ploča",
  "block.minecraft.orange_stained_glass_pane": "narandžasta staklena ploča",
  "block.minecraft.magenta_stained_glass_pane": "purpurnocrvena staklena ploča",
  "block.minecraft.light_blue_stained_glass_pane": "svijetlo plava staklena ploča",
  "block.minecraft.yellow_stained_glass_pane": "žuta staklena ploča",
  "block.minecraft.lime_stained_glass_pane": "svijetlo zelena staklena ploča",
  "block.minecraft.pink_stained_glass_pane": "roza staklena ploča",
  "block.minecraft.gray_stained_glass_pane": "siva staklena ploča",
  "block.minecraft.light_gray_stained_glass_pane": "svijetlo siva staklena ploča",
  "block.minecraft.cyan_stained_glass_pane": "cijan staklena ploča",
  "block.minecraft.purple_stained_glass_pane": "ljubičasta staklena ploča",
  "block.minecraft.blue_stained_glass_pane": "plava staklena ploča",
  "block.minecraft.brown_stained_glass_pane": "braon staklena ploča",
  "block.minecraft.green_stained_glass_pane": "zelena staklena ploča",
  "block.minecraft.red_stained_glass_pane": "crvena staklena ploča",
  "block.minecraft.black_stained_glass_pane": "crna staklena ploča",
  "block.minecraft.prismarine": "prizmarin",
  "block.minecraft.prismarine_bricks": "cigle prizmarina",
  "block.minecraft.dark_prismarine": "tamni prizmarin",
  "block.minecraft.prismarine_stairs": "stepenice od prizmarina",
  "block.minecraft.prismarine_brick_stairs": "prizmarinsko ciglaste stepenice",
  "block.minecraft.dark_prismarine_stairs": "stepenice od tamnog prizmarina",
  "block.minecraft.sea_lantern": "podvodni fenjer",
  "block.minecraft.red_sandstone": "crveni pješčani kamen",
  "block.minecraft.chiseled_red_sandstone": "klesani crveni pješčani kamen",
  "block.minecraft.cut_red_sandstone": "izrezani crveni pješčani kamen",
  "block.minecraft.red_sandstone_stairs": "crvene pješčane stepenice",
  "block.minecraft.repeating_command_block": "ponavljajući naredbeni blok",
  "block.minecraft.chain_command_block": "lančani naredbeni blok",
  "block.minecraft.magma_block": "blok magme",
  "block.minecraft.nether_wart_block": "neder lišaj",
  "block.minecraft.warped_wart_block": "blok ludog lišaja",
  "block.minecraft.red_nether_bricks": "crvena neder cigla",
  "block.minecraft.bone_block": "koštani blok",
  "block.minecraft.structure_void": "strukturna praznina",
  "block.minecraft.observer": "posmatrač",
  "block.minecraft.shulker_box": "kutija shulkera",
  "block.minecraft.white_shulker_box": "bijela kutija shulkera",
  "block.minecraft.orange_shulker_box": "narandžasta kutija shulkera",
  "block.minecraft.magenta_shulker_box": "purpurnocrvena kutija shulkera",
  "block.minecraft.light_blue_shulker_box": "svijetlo plava kutija shulkera",
  "block.minecraft.yellow_shulker_box": "žuta kutija shulkera",
  "block.minecraft.lime_shulker_box": "svijetlo zelena kutija shulkera",
  "block.minecraft.pink_shulker_box": "roza kutija shulkera",
  "block.minecraft.gray_shulker_box": "siva kutija shulkera",
  "block.minecraft.light_gray_shulker_box": "svijetlo siva kutija shulkera",
  "block.minecraft.cyan_shulker_box": "cijan kutija shulkera",
  "block.minecraft.purple_shulker_box": "ljubičasta kutija shulkera",
  "block.minecraft.blue_shulker_box": "plava kutija shulkera",
  "block.minecraft.brown_shulker_box": "braon kutija shulkera",
  "block.minecraft.green_shulker_box": "zelena kutija shulkera",
  "block.minecraft.red_shulker_box": "crvena kutija shulkera",
  "block.minecraft.black_shulker_box": "crna kutija shulkera",
  "block.minecraft.white_glazed_terracotta": "bijela glazirana terakota",
  "block.minecraft.orange_glazed_terracotta": "narandžasta glazirana terakota",
  "block.minecraft.magenta_glazed_terracotta": "purpurcrvena glazirana terakota",
  "block.minecraft.light_blue_glazed_terracotta": "svijetlo plava glazirana terakota",
  "block.minecraft.yellow_glazed_terracotta": "žuta glazirana terakota",
  "block.minecraft.lime_glazed_terracotta": "svijetlo zelena glazirana terakota",
  "block.minecraft.pink_glazed_terracotta": "roza glazirana terakota",
  "block.minecraft.gray_glazed_terracotta": "siva glazirana terakota",
  "block.minecraft.light_gray_glazed_terracotta": "svijetlo siva glazirana terakota",
  "block.minecraft.cyan_glazed_terracotta": "cijan glazirana terakota",
  "block.minecraft.purple_glazed_terracotta": "ljubičasta glazirana terakota",
  "block.minecraft.blue_glazed_terracotta": "plava glazirana terakota",
  "block.minecraft.brown_glazed_terracotta": "braon glazirana terakota",
  "block.minecraft.green_glazed_terracotta": "zelena glazirana terakota",
  "block.minecraft.red_glazed_terracotta": "crvena glazirana terakota",
  "block.minecraft.black_glazed_terracotta": "crna glazirana terakota",
  "block.minecraft.white_concrete": "bijeli beton",
  "block.minecraft.orange_concrete": "narandžasti beton",
  "block.minecraft.magenta_concrete": "purpurcrveni beton",
  "block.minecraft.light_blue_concrete": "svijetlo plavi beton",
  "block.minecraft.yellow_concrete": "žuti beton",
  "block.minecraft.lime_concrete": "svijetlo sivi beton",
  "block.minecraft.pink_concrete": "rozi beton",
  "block.minecraft.gray_concrete": "sivi beton",
  "block.minecraft.light_gray_concrete": "svijetlo sivi beton",
  "block.minecraft.cyan_concrete": "cijan beton",
  "block.minecraft.purple_concrete": "ljubičasti beton",
  "block.minecraft.blue_concrete": "plavi beton",
  "block.minecraft.brown_concrete": "braon beton",
  "block.minecraft.green_concrete": "zeleni beton",
  "block.minecraft.red_concrete": "crveni beton",
  "block.minecraft.black_concrete": "crni beton",
  "block.minecraft.white_concrete_powder": "bijeli betonski prah",
  "block.minecraft.orange_concrete_powder": "narandžasti betonski prah",
  "block.minecraft.magenta_concrete_powder": "purpurnocrveni betonski prah",
  "block.minecraft.light_blue_concrete_powder": "svijetlo plavi betonski prah",
  "block.minecraft.yellow_concrete_powder": "žuti betonski prah",
  "block.minecraft.lime_concrete_powder": "svijetlo zeleni betonski prah",
  "block.minecraft.pink_concrete_powder": "rozi betonski prah",
  "block.minecraft.gray_concrete_powder": "sivi betonski prah",
  "block.minecraft.light_gray_concrete_powder": "svijetlo sivi betonski prah",
  "block.minecraft.cyan_concrete_powder": "cijan betonski prah",
  "block.minecraft.purple_concrete_powder": "ljubičasti betonski prah",
  "block.minecraft.blue_concrete_powder": "plavi betonski prah",
  "block.minecraft.brown_concrete_powder": "braon betonski prah",
  "block.minecraft.green_concrete_powder": "zeleni betonski prah",
  "block.minecraft.red_concrete_powder": "crveni betonski prah",
  "block.minecraft.black_concrete_powder": "crni betonski prah",
  "block.minecraft.turtle_egg": "jaje kornjače",
  "block.minecraft.dead_tube_coral_block": "mrtvi cijevasti koralni blok",
  "block.minecraft.dead_brain_coral_block": "mrtvi mozgasti koralni blok",
  "block.minecraft.dead_bubble_coral_block": "mrtvi mjehurasti koralni blok",
  "block.minecraft.dead_fire_coral_block": "mrtvi vatreni koralni blok",
  "block.minecraft.dead_horn_coral_block": "mrtvi rogasti koralni blok",
  "block.minecraft.tube_coral_block": "cijevasti koralni blok",
  "block.minecraft.brain_coral_block": "mozgasti koralni blok",
  "block.minecraft.bubble_coral_block": "mjehurasti koralni blok",
  "block.minecraft.fire_coral_block": "vatreni koralni blok",
  "block.minecraft.horn_coral_block": "rogasti koralni blok",
  "block.minecraft.tube_coral": "cijevasti koral",
  "block.minecraft.brain_coral": "mozgasti koral",
  "block.minecraft.bubble_coral": "mjehurasti koral",
  "block.minecraft.fire_coral": "vatreni koral",
  "block.minecraft.horn_coral": "rogasti koral",
  "block.minecraft.dead_brain_coral": "mrtvi mozgasti koral",
  "block.minecraft.dead_bubble_coral": "mrtvi mjehurasti koral",
  "block.minecraft.dead_fire_coral": "mrtvi vatreni koral",
  "block.minecraft.dead_horn_coral": "mrtvi rogasti koral",
  "block.minecraft.dead_tube_coral": "mrtvi cijevasti koral",
  "block.minecraft.tube_coral_fan": "lepeza od cijevastog korala",
  "block.minecraft.brain_coral_fan": "lepeza od mozgastog korala",
  "block.minecraft.bubble_coral_fan": "lepeza od mjehurastog korala",
  "block.minecraft.fire_coral_fan": "lepeza od vatrenog korala",
  "block.minecraft.horn_coral_fan": "lepeza od rogastog korala",
  "block.minecraft.dead_tube_coral_fan": "lepeza od mrtvog cijevastog korala",
  "block.minecraft.dead_brain_coral_fan": "lepeza od mrtvog mozgastog korala",
  "block.minecraft.dead_bubble_coral_fan": "lepeza od mrtvog mjehurastog korala",
  "block.minecraft.dead_fire_coral_fan": "lepeza od mrtvog vatrenog korala",
  "block.minecraft.dead_horn_coral_fan": "lepeza od mrtvog rogastog korala",
  "block.minecraft.blue_ice": "plavi led",
  "block.minecraft.conduit": "konduktor",
  "block.minecraft.polished_granite_stairs": "uglancane stepenice od granita",
  "block.minecraft.smooth_red_sandstone_stairs": "glatko crvene pješčane stepenice",
  "block.minecraft.mossy_stone_brick_stairs": "obrasle kamene stepenice",
  "block.minecraft.polished_diorite_stairs": "uglancane diorit stepenice",
  "block.minecraft.mossy_cobblestone_stairs": "obrasle kaldrmske stepenice",
  "block.minecraft.end_stone_brick_stairs": "stepenice od kamenih cigla iz enda",
  "block.minecraft.stone_stairs": "kamene stepenice",
  "block.minecraft.smooth_sandstone_stairs": "glatke pješčane stepenice",
  "block.minecraft.smooth_quartz_stairs": "glatke kvarcne stepenice",
  "block.minecraft.granite_stairs": "granitne stepenice",
  "block.minecraft.andesite_stairs": "andezit stepenice",
  "block.minecraft.red_nether_brick_stairs": "stepenice od crvenih cigla iz nedera",
  "block.minecraft.polished_andesite_stairs": "glatke stepenice od andezita",
  "block.minecraft.diorite_stairs": "diorit stepenice",
  "block.minecraft.polished_granite_slab": "uglancana granitna ploča",
  "block.minecraft.smooth_red_sandstone_slab": "glatka crvena pješčana ploča",
  "block.minecraft.mossy_stone_brick_slab": "obrasla kamena ploča",
  "block.minecraft.polished_diorite_slab": "glatka ploča od diorita",
  "block.minecraft.mossy_cobblestone_slab": "obrasla kaldrmska stepenica",
  "block.minecraft.end_stone_brick_slab": "ploča od kamenih end cigala",
  "block.minecraft.smooth_sandstone_slab": "glatka pješčana ploča",
  "block.minecraft.smooth_quartz_slab": "glatka kvarcna ploča",
  "block.minecraft.granite_slab": "ploča od granita",
  "block.minecraft.andesite_slab": "ploča od andezita",
  "block.minecraft.red_nether_brick_slab": "crvena ploča od neder cigle",
  "block.minecraft.polished_andesite_slab": "glatka ploča od andzita",
  "block.minecraft.diorite_slab": "ploča od diorita",
  "block.minecraft.scaffolding": "skele",
  "block.minecraft.iron_door": "gvozdena vrata",
  "block.minecraft.oak_door": "vrata od hrasta",
  "block.minecraft.spruce_door": "vrata od smreke",
  "block.minecraft.birch_door": "vrata od breze",
  "block.minecraft.jungle_door": "vrata od džungle",
  "block.minecraft.acacia_door": "vrata od bagrema",
  "block.minecraft.dark_oak_door": "vrata od tamnog hrasta",
  "block.minecraft.crimson_door": "grimizna vrata",
  "block.minecraft.warped_door": "izopačena vrata",
  "block.minecraft.repeater": "redstone pojačivač",
  "block.minecraft.comparator": "redstone komparator",
  "block.minecraft.structure_block": "strukturni blok",
  "block.minecraft.jigsaw": "blok slagalica",
  "item.minecraft.turtle_helmet": "kornjačin oklop□□kada je na glavi:□+2 oklop",
  "item.minecraft.scute": "štit",
  "item.minecraft.iron_shovel": "gvozdena lopata□□kada je u glavnoj ruci:□+3.5 jačina napada□-3 brzina napada",
  "item.minecraft.iron_pickaxe": "gvozdeni kramp□□kada je u glavnoj ruci:□+3 jačina napada□-2.8 brzina napada",
  "item.minecraft.iron_axe": "gvozdena sjekira□□kada je u glavnoj ruci:□+8 jačina napada□-3.1 brzina napada",
  "item.minecraft.flint_and_steel": "kremen i čelik",
  "item.minecraft.apple": "jabuka",
  "item.minecraft.bow": "luk",
  "item.minecraft.arrow": "strijela",
  "item.minecraft.coal": "ugalj",
  "item.minecraft.charcoal": "drveni ugalj",
  "item.minecraft.diamond": "dijamant",
  "item.minecraft.iron_ingot": "gvozdena poluga",
  "item.minecraft.gold_ingot": "zlatna poluga",
  "item.minecraft.netherite_ingot": "nederitska poluga",
  "item.minecraft.netherite_scrap": "komad nederita",
  "item.minecraft.iron_sword": "gvozdeni mač□□kada je u glavnoj ruci:□+5 jačina napada□-2.4 brzina napada",
  "item.minecraft.wooden_sword": "drveni mač□□kada je u glavnoj ruci:□+3 jačina napada□-2.4 brzina napada",
  "item.minecraft.wooden_shovel": "drvena lopata□□kada je u glavnoj ruci:□+1.5 jačina napada□-3 brzina napada",
  "item.minecraft.wooden_pickaxe": "drveni kramp□□kada je u glavnoj ruci:□+1 jačina napada□-2.8 brzina napada",
  "item.minecraft.wooden_axe": "drvena sjekira□□kada je u glavnoj ruci:□+6 jačina napada□-3.2 brzina napada",
  "item.minecraft.stone_sword": "kameni mač□□kada je u glavnoj ruci:□+4 jačina napada□-2.4 brzina napada",
  "item.minecraft.stone_shovel": "kamena lopata□□kada je u glavnoj ruci:□+2.5 jačina napada□-3 brzina napada",
  "item.minecraft.stone_pickaxe": "kameni kramp□□kada je u glavnoj ruci:□+2 jačina napada□-2.8 brzina napada",
  "item.minecraft.stone_axe": "kamena sjekira□□kada je u glavnoj ruci:□+8 jačina napada□-3.2 brzina napada",
  "item.minecraft.diamond_sword": "dijamantski mač□□kada je u glavnoj ruci:□+6 jačina napada□-2.4 brzina napada",
  "item.minecraft.diamond_shovel": "dijamantska lopata□□kada je u glavnoj ruci:□+4.5 jačina napada□-3 brzina napada",
  "item.minecraft.diamond_pickaxe": "dijamantski kramp□□kada je u glavnoj ruci:□+4 jačina napada□-2.8 brzina napada",
  "item.minecraft.diamond_axe": "dijamantska sjekira□□kada je u glavnoj ruci:□+8 jačina napada□-3 brzina napada",
  "item.minecraft.stick": "štap",
  "item.minecraft.bowl": "posuda",
  "item.minecraft.mushroom_stew": "čorba od gljiva",
  "item.minecraft.golden_sword": "zlatni mač□□kada je u glavnoj ruci:□+3 jačina napada□-2.4 brzina napada",
  "item.minecraft.golden_shovel": "zlatna lopata□□kada je u glavnoj ruci:□+1.5 jačina napada□-3 brzina napada",
  "item.minecraft.golden_pickaxe": "zlatni kramp□□kada je u glavnoj ruci:□+1 jačina napada□-2.8 brzina napada",
  "item.minecraft.golden_axe": "zlatna sjekira□□kada je u glavnoj ruci:□+6 jačina napada□-3 brzina napada",
  "item.minecraft.netherite_sword": "netheritski mač□□kada je u glavnoj ruci:□+7 jačina napada□-2.4 brzina napada",
  "item.minecraft.netherite_shovel": "nederitska lopata□□kada je u glavnoj ruci:□+5.5 jačina napada□-3 brzina napada",
  "item.minecraft.netherite_pickaxe": "nederitski kramp□□kada je u glavnoj ruci:□+5 jačina napada□-2.8 brzina napada",
  "item.minecraft.netherite_axe": "nederitska sjekira□□kada je u glavnoj ruci:□+9 jačina napada□-3 brzina napada",
  "item.minecraft.string": "nit",
  "item.minecraft.feather": "pero",
  "item.minecraft.gunpowder": "barut",
  "item.minecraft.wooden_hoe": "drvena motika□□kada je u glavnoj ruci:□-3 brzina napada",
  "item.minecraft.stone_hoe": "kamena motika□□kada je u glavnoj ruci:□-2 brzina napada",
  "item.minecraft.iron_hoe": "gvozdena motika□□kada je u glavnoj ruci:□-1 brzina napada",
  "item.minecraft.diamond_hoe": "dijamantska motika□□kada je u glavnoj ruci:",
  "item.minecraft.golden_hoe": "zlatna motika□□kada je u glavnoj ruci:□-3 brzina napada",
  "item.minecraft.netherite_hoe": "nederitska motika□□kada je u glavnoj ruci:",
  "item.minecraft.wheat_seeds": "sjeme pšenice",
  "item.minecraft.wheat": "pšenica",
  "item.minecraft.bread": "hljeb",
  "item.minecraft.leather_helmet": "kožna kapa□□kada je na glavi:□+1 oklop",
  "item.minecraft.leather_chestplate": "kožni prsluk□□kada je na tijelu:□+3 oklop",
  "item.minecraft.leather_leggings": "kožne pantalone□□kada je na nogama:□+2 oklop",
  "item.minecraft.leather_boots": "kožne čizme□□kada je na stopalima:□+1 oklop",
  "item.minecraft.chainmail_helmet": "verižni šljem□□kada je na glavi:□+2 oklop",
  "item.minecraft.chainmail_chestplate": "verižni oklop□□kada je na tijelu:□+5 oklop",
  "item.minecraft.chainmail_leggings": "verižne nogavice□□kada je na nogama:□+4 oklop",
  "item.minecraft.chainmail_boots": "verižne čizme□□kada je na stopalima:□+1 oklop",
  "item.minecraft.iron_helmet": "gvozdeni šljem□□kada je na glavi:□+2 oklop",
  "item.minecraft.iron_chestplate": "gvozdeni oklop□□kada je na tijelu:□+6 oklop",
  "item.minecraft.iron_leggings": "gvozdene nogavice□□kada je na nogama:□+5 oklop",
  "item.minecraft.iron_boots": "gvozdene čizme□□kada je na stopalima:□+2 oklop",
  "item.minecraft.diamond_helmet": "dijamantski šljem□□kada je na glavi:□+3 oklop□+2 izdržljivost oklopa",
  "item.minecraft.diamond_chestplate": "dijamantski oklop□□kada je na tijelu:□+8 oklop□+2 izdržljivost oklopa",
  "item.minecraft.diamond_leggings": "dijamantske nogavice□□kada je na nogama:□+6 oklop□+2 izdržljivost oklopa",
  "item.minecraft.diamond_boots": "dijamantske čizme□□kada je na stopalima:□+3 oklop□+2 izdržljivost oklopa",
  "item.minecraft.golden_helmet": "zlatni šljem□□kada je na glavi:□+2 oklop",
  "item.minecraft.golden_chestplate": "zlatni oklop□□kada je na tijelu:□+5 oklop",
  "item.minecraft.golden_leggings": "zlatne nogavice□□kada je na nogama:□+3 oklop",
  "item.minecraft.golden_boots": "zlatne čizme□□kada je na stopalima:□+1 oklop",
  "item.minecraft.netherite_helmet": "nederitski šljem□□kada je na glavi:□+3 oklop□+3 izdržljivost oklopa□+1 otpor na odbacivanje",
  "item.minecraft.netherite_chestplate": "nederitski oklop□□kada je na tijelu:□+8 oklop□+3 izdržljivost oklopa□+1 otpor na odbacivanje",
  "item.minecraft.netherite_leggings": "nederitske nogavice□□kada je na nogama:□+6 oklop□+3 izdržljivost oklopa□+1 otpor na odbacivanje",
  "item.minecraft.netherite_boots": "nederitske čizme□□kada je na stopalima:□+3 oklop□+3 izdržljivost oklopa□+1 otpor na odbacivanje",
  "item.minecraft.flint": "kremen",
  "item.minecraft.porkchop": "sirova svinjetina",
  "item.minecraft.cooked_porkchop": "pečena svinjetina",
  "item.minecraft.painting": "slika",
  "item.minecraft.golden_apple": "zlatna jabuka",
  "item.minecraft.enchanted_golden_apple": "začarana zlatna jabuka",
  "block.minecraft.oak_sign": "hrastov znak",
  "block.minecraft.spruce_sign": "smrekin znak",
  "block.minecraft.birch_sign": "breza znak",
  "block.minecraft.jungle_sign": "džungla znak",
  "block.minecraft.acacia_sign": "akacija znak",
  "block.minecraft.dark_oak_sign": "tamni hrast znak",
  "block.minecraft.crimson_sign": "grimizni znak",
  "block.minecraft.warped_sign": "izopačeni znak",
  "item.minecraft.bucket": "kanta",
  "item.minecraft.water_bucket": "kanta vode",
  "item.minecraft.lava_bucket": "kanta magme",
  "item.minecraft.minecart": "vagon",
  "item.minecraft.saddle": "sedlo",
  "item.minecraft.redstone": "prah redstona",
  "item.minecraft.snowball": "grudva",
  "item.minecraft.oak_boat": "hrastov čamac",
  "item.minecraft.leather": "koža",
  "item.minecraft.milk_bucket": "kanta mlijeka",
  "item.minecraft.pufferfish_bucket": "kanta sa ribom pumpicom",
  "item.minecraft.salmon_bucket": "kanta sa lososom",
  "item.minecraft.cod_bucket": "kanta sa bakalarom",
  "item.minecraft.tropical_fish_bucket": "kanta sa tropskom ribom",
  "item.minecraft.brick": "cigla",
  "item.minecraft.clay_ball": "glinena kugla",
  "block.minecraft.dried_kelp_block": "osušen blok morske alge",
  "item.minecraft.paper": "papir",
  "item.minecraft.book": "knjiga",
  "item.minecraft.slime_ball": "lopta od sluzi",
  "item.minecraft.chest_minecart": "vagon sa kovčegom",
  "item.minecraft.furnace_minecart": "vagon sa peći",
  "item.minecraft.egg": "jaje",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "štap za pecanje",
  "item.minecraft.clock": "sat",
  "item.minecraft.glowstone_dust": "prah žarkamena",
  "item.minecraft.cod": "sirov bakalar",
  "item.minecraft.salmon": "sirovi losos",
  "item.minecraft.tropical_fish": "tropska riba",
  "item.minecraft.pufferfish": "pumpica",
  "item.minecraft.cooked_cod": "isprženi bakalar",
  "item.minecraft.cooked_salmon": "kuvani losos",
  "item.minecraft.ink_sac": "vrećica sa mastilom",
  "item.minecraft.red_dye": "crvena boja",
  "item.minecraft.green_dye": "zelena boja",
  "item.minecraft.cocoa_beans": "kakao zrnevlje",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "ljubičasti pigment",
  "item.minecraft.cyan_dye": "cijan pigment",
  "item.minecraft.light_gray_dye": "svijetlo sivi pigment",
  "item.minecraft.gray_dye": "sivi pigment",
  "item.minecraft.pink_dye": "ružičasti pigment",
  "item.minecraft.lime_dye": "svijetlo zeleni pigment",
  "item.minecraft.yellow_dye": "žuta boja",
  "item.minecraft.light_blue_dye": "svijetlo plavi pigment",
  "item.minecraft.magenta_dye": "purpurnocrveni pigment",
  "item.minecraft.orange_dye": "narandžasti pigment",
  "item.minecraft.bone_meal": "koštano brašno",
  "item.minecraft.blue_dye": "plava boja",
  "item.minecraft.brown_dye": "braon boja",
  "item.minecraft.black_dye": "crna boja",
  "item.minecraft.white_dye": "bijela boja",
  "item.minecraft.bone": "kost",
  "item.minecraft.sugar": "šećer",
  "block.minecraft.cake": "torta",
  "block.minecraft.white_bed": "bijeli krevet",
  "block.minecraft.orange_bed": "narandžasti krevet",
  "block.minecraft.magenta_bed": "purpurnocrveni krevet",
  "block.minecraft.light_blue_bed": "svijetlo plavi krevet",
  "block.minecraft.yellow_bed": "žuti krevet",
  "block.minecraft.lime_bed": "svijetlo zeleni krevet",
  "block.minecraft.pink_bed": "rozi krevet",
  "block.minecraft.gray_bed": "sivi krevet",
  "block.minecraft.light_gray_bed": "svijetlo sivi krevet",
  "block.minecraft.cyan_bed": "cijan krevet",
  "block.minecraft.purple_bed": "ljubičasti krevet",
  "block.minecraft.blue_bed": "plavi krevet",
  "block.minecraft.brown_bed": "braon krevet",
  "block.minecraft.green_bed": "zeleni krevet",
  "block.minecraft.red_bed": "crveni krevet",
  "block.minecraft.black_bed": "crni krevet",
  "item.minecraft.cookie": "kolačić",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "makaze",
  "item.minecraft.melon_slice": "kriška lubenice",
  "item.minecraft.dried_kelp": "osučena alga",
  "item.minecraft.pumpkin_seeds": "sjemena bundeve",
  "item.minecraft.melon_seeds": "sjemena lubenice",
  "item.minecraft.beef": "sirova govedina",
  "item.minecraft.cooked_beef": "biftek",
  "item.minecraft.chicken": "sirova piletina",
  "item.minecraft.cooked_chicken": "pečena piletina",
  "item.minecraft.rotten_flesh": "trulo meso",
  "item.minecraft.ender_pearl": "ender biser",
  "item.minecraft.blaze_rod": "plamen štap",
  "item.minecraft.ghast_tear": "c418 - chirp",
  "item.minecraft.gold_nugget": "grumen zlata",
  "item.minecraft.nether_wart": "neder lišaj",
  "item.minecraft.potion": "nenapravljiv napitak□bez efekata",
  "item.minecraft.glass_bottle": "staklena bočica",
  "item.minecraft.spider_eye": "paukovo oko",
  "item.minecraft.fermented_spider_eye": "fermentisano paukovo oko",
  "item.minecraft.blaze_powder": "plamen prah",
  "item.minecraft.magma_cream": "magma krem",
  "block.minecraft.brewing_stand": "postolje za napitke",
  "block.minecraft.cauldron": "kotao",
  "item.minecraft.ender_eye": "oko endera",
  "item.minecraft.glistering_melon_slice": "svetlucava kriška lubenice",
  "item.minecraft.bat_spawn_egg": "jaje slijepog miša",
  "item.minecraft.bee_spawn_egg": "jaje za stvaranje pčela",
  "item.minecraft.blaze_spawn_egg": "jaje vatrenog",
  "item.minecraft.cat_spawn_egg": "jaje za stvaranje mačke",
  "item.minecraft.cave_spider_spawn_egg": "jaje pećinskog pauka",
  "item.minecraft.chicken_spawn_egg": "jaje kokoške",
  "item.minecraft.cod_spawn_egg": "jaje bakalara",
  "item.minecraft.cow_spawn_egg": "jaje krave",
  "item.minecraft.creeper_spawn_egg": "jaje kripera",
  "item.minecraft.dolphin_spawn_egg": "jaje delfina",
  "item.minecraft.donkey_spawn_egg": "jaje magarca",
  "item.minecraft.drowned_spawn_egg": "jaje utopljenika",
  "item.minecraft.elder_guardian_spawn_egg": "jaje starog čuvara",
  "item.minecraft.enderman_spawn_egg": "jaje endermena",
  "item.minecraft.endermite_spawn_egg": "jaje endermita",
  "item.minecraft.evoker_spawn_egg": "jaje vračara",
  "item.minecraft.fox_spawn_egg": "jaje lisice",
  "item.minecraft.ghast_spawn_egg": "jaje gasta",
  "item.minecraft.guardian_spawn_egg": "jaje čuvara",
  "item.minecraft.hoglin_spawn_egg": "jaje hoglina",
  "item.minecraft.horse_spawn_egg": "jaje konja",
  "item.minecraft.husk_spawn_egg": "jaje pustinjskog zombija",
  "item.minecraft.llama_spawn_egg": "jaje lame",
  "item.minecraft.magma_cube_spawn_egg": "jaje kocke magme",
  "item.minecraft.mooshroom_spawn_egg": "jaje mooshruma",
  "item.minecraft.mule_spawn_egg": "jaje mazge",
  "item.minecraft.ocelot_spawn_egg": "jaje divlje mačke",
  "item.minecraft.panda_spawn_egg": "jaje za stvaranje pande",
  "item.minecraft.parrot_spawn_egg": "jaje papagaja",
  "item.minecraft.phantom_spawn_egg": "jaje fantoma",
  "item.minecraft.pig_spawn_egg": "jaje svinje",
  "item.minecraft.piglin_spawn_egg": "jaje paklenog praseta",
  "item.minecraft.pillager_spawn_egg": "jaje za stvaranje razbojnika",
  "item.minecraft.polar_bear_spawn_egg": "jaje polarnog medvjeda",
  "item.minecraft.pufferfish_spawn_egg": "jaje pumpice",
  "item.minecraft.rabbit_spawn_egg": "jaje zeca",
  "item.minecraft.ravager_spawn_egg": "jaje razarača",
  "item.minecraft.salmon_spawn_egg": "jaje lososa",
  "item.minecraft.sheep_spawn_egg": "jaje ovce",
  "item.minecraft.shulker_spawn_egg": "jaje shulkera",
  "item.minecraft.silverfish_spawn_egg": "jaje srebrne ribe",
  "item.minecraft.skeleton_spawn_egg": "jaje kostura",
  "item.minecraft.skeleton_horse_spawn_egg": "jaje kostura konja",
  "item.minecraft.slime_spawn_egg": "jaje sluzi",
  "item.minecraft.spider_spawn_egg": "jaje pauka",
  "item.minecraft.squid_spawn_egg": "jaje lignje",
  "item.minecraft.stray_spawn_egg": "jaje lutalice",
  "item.minecraft.strider_spawn_egg": "jaje šetača",
  "item.minecraft.trader_llama_spawn_egg": "jaje trgovca lame",
  "item.minecraft.tropical_fish_spawn_egg": "jaje tropske ribe",
  "item.minecraft.turtle_spawn_egg": "jaje kornjače",
  "item.minecraft.vex_spawn_egg": "jaje duha",
  "item.minecraft.villager_spawn_egg": "jaje seljaka",
  "item.minecraft.vindicator_spawn_egg": "jaje osvetnika",
  "item.minecraft.wandering_trader_spawn_egg": "jaje lutajućeg trgovca",
  "item.minecraft.witch_spawn_egg": "jaje veštice",
  "item.minecraft.wither_skeleton_spawn_egg": "jaje vider kostura",
  "item.minecraft.wolf_spawn_egg": "jaje vuka",
  "item.minecraft.zoglin_spawn_egg": "jaje zoglina",
  "item.minecraft.zombie_spawn_egg": "jaje zombija",
  "item.minecraft.zombie_horse_spawn_egg": "jaje zombi konja",
  "item.minecraft.zombie_villager_spawn_egg": "jaje seljaka zombija",
  "item.minecraft.zombified_piglin_spawn_egg": "jaje za stvaranje paklenog zombi praseta",
  "item.minecraft.experience_bottle": "boca za čini",
  "item.minecraft.fire_charge": "vatrena lopta",
  "item.minecraft.writable_book": "knjiga i pero",
  "item.minecraft.written_book": "napisana knjiga",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "ram za predmete",
  "block.minecraft.flower_pot": "saksija",
  "item.minecraft.carrot": "šargarepa",
  "item.minecraft.potato": "krompir",
  "item.minecraft.baked_potato": "pečeni krompir",
  "item.minecraft.poisonous_potato": "otrovni krompir",
  "item.minecraft.map": "prazna mapa",
  "item.minecraft.golden_carrot": "zlatna šargarepa",
  "block.minecraft.skeleton_skull": "kosturova lobanja",
  "block.minecraft.wither_skeleton_skull": "lobanja vider skeletona",
  "block.minecraft.player_head": "lobanja od igrača",
  "block.minecraft.zombie_head": "glava zombija",
  "block.minecraft.creeper_head": "kriperova glava",
  "block.minecraft.dragon_head": "zmajeva glava",
  "item.minecraft.carrot_on_a_stick": "šargarepa na štapu",
  "item.minecraft.warped_fungus_on_a_stick": "izopačena gljiva na štapu",
  "item.minecraft.nether_star": "neder zvezda",
  "item.minecraft.pumpkin_pie": "pita od bundeve",
  "item.minecraft.firework_rocket": "vatrometska raketa",
  "item.minecraft.firework_star": "vatrometska zvijezda",
  "item.minecraft.enchanted_book": "začarana knjiga",
  "item.minecraft.nether_brick": "neder cigla",
  "item.minecraft.quartz": "neder kvarc",
  "item.minecraft.tnt_minecart": "vagon sa dinamitom",
  "item.minecraft.hopper_minecart": "vagon sa hoperom",
  "item.minecraft.prismarine_shard": "krhotina prizmarina",
  "item.minecraft.prismarine_crystals": "kristal prizmarina",
  "item.minecraft.rabbit": "sirova zečetina",
  "item.minecraft.cooked_rabbit": "pečena zečetina",
  "item.minecraft.rabbit_stew": "gulaš od zeca",
  "item.minecraft.rabbit_foot": "zečja šapa",
  "item.minecraft.rabbit_hide": "zečja koža",
  "item.minecraft.armor_stand": "postolje za oklop",
  "item.minecraft.iron_horse_armor": "gvozdeni konjski oklop",
  "item.minecraft.golden_horse_armor": "zlatni konjski oklop",
  "item.minecraft.diamond_horse_armor": "dijamantski konjski oklop",
  "item.minecraft.leather_horse_armor": "kožni konjski armor",
  "item.minecraft.lead": "povodac",
  "item.minecraft.name_tag": "oznaka imena",
  "item.minecraft.command_block_minecart": "vagon sa komandnim blokom",
  "item.minecraft.mutton": "sirova jagnjetina",
  "item.minecraft.cooked_mutton": "pečena jagnjetina",
  "block.minecraft.white_banner": "bijela zastava",
  "block.minecraft.orange_banner": "narandžasta zastava",
  "block.minecraft.magenta_banner": "purpurnocrvena zastava",
  "block.minecraft.light_blue_banner": "svijetlo plava zastava",
  "block.minecraft.yellow_banner": "žuta zastava",
  "block.minecraft.lime_banner": "svijetlo zelena zastava",
  "block.minecraft.pink_banner": "roza zastava",
  "block.minecraft.gray_banner": "siva zastava",
  "block.minecraft.light_gray_banner": "svijetlo siva zastava",
  "block.minecraft.cyan_banner": "cijan zastava",
  "block.minecraft.purple_banner": "ljubičasta zastava",
  "block.minecraft.blue_banner": "plava zastava",
  "block.minecraft.brown_banner": "braon zastava",
  "block.minecraft.green_banner": "zelena zastava",
  "block.minecraft.red_banner": "crvena zastava",
  "block.minecraft.black_banner": "crna zastava",
  "item.minecraft.end_crystal": "end kristal",
  "item.minecraft.chorus_fruit": "horus voćka",
  "item.minecraft.popped_chorus_fruit": "puknuto horus voće",
  "item.minecraft.beetroot": "cvekla",
  "item.minecraft.beetroot_seeds": "sjemenke cvekle",
  "item.minecraft.beetroot_soup": "supa od cvekle",
  "item.minecraft.dragon_breath": "zmajev dah",
  "item.minecraft.splash_potion": "rasprskujući nenapravljivi napitak□bez efekata",
  "item.minecraft.spectral_arrow": "svijetleća strijela",
  "item.minecraft.tipped_arrow": "nepravljena umočena strijela□bez efekata",
  "item.minecraft.lingering_potion": "dugotrajni nenapravljiv napitak□bez efekata",
  "item.minecraft.shield": "štit",
  "item.minecraft.elytra": "krila",
  "item.minecraft.spruce_boat": "smrekin čamac",
  "item.minecraft.birch_boat": "brezin čamac",
  "item.minecraft.jungle_boat": "džungla čamac",
  "item.minecraft.acacia_boat": "čamac od bagrema",
  "item.minecraft.dark_oak_boat": "tamni hrastov čamac",
  "item.minecraft.totem_of_undying": "totem besmrtnosti",
  "item.minecraft.shulker_shell": "shulker ljuska",
  "item.minecraft.iron_nugget": "grumen gvožđa",
  "item.minecraft.knowledge_book": "knjiga znanja",
  "item.minecraft.debug_stick": "debug štapić",
  "item.minecraft.music_disc_13": "muzička ploča□c418 - 13",
  "item.minecraft.music_disc_cat": "muzička ploča□c418 - cat",
  "item.minecraft.music_disc_blocks": "muzička ploča□c418 - blocks",
  "item.minecraft.music_disc_chirp": "muzička ploča□c418 - chirp",
  "item.minecraft.music_disc_far": "muzička ploča□c418 - far",
  "item.minecraft.music_disc_mall": "muzička ploča□c418 - mall",
  "item.minecraft.music_disc_mellohi": "muzička ploča□c418 - mellohi",
  "item.minecraft.music_disc_stal": "muzička ploča□c418 - stal",
  "item.minecraft.music_disc_strad": "muzička ploča□c418 - strad",
  "item.minecraft.music_disc_ward": "muzička ploča□c418 - ward",
  "item.minecraft.music_disc_11": "muzička ploča□c418 - 11",
  "item.minecraft.music_disc_wait": "muzička ploča□c418 - wait",
  "item.minecraft.music_disc_pigstep": "muzička ploča□lena rejn - pigstep",
  "item.minecraft.trident": "trozubac□□kada je u glavnoj ruci:□+8 jačina napada□-2.9 brzina napada",
  "item.minecraft.phantom_membrane": "fantom membrana",
  "item.minecraft.nautilus_shell": "nautilus školjka",
  "item.minecraft.heart_of_the_sea": "srce mora",
  "item.minecraft.crossbow": "samostrel",
  "item.minecraft.suspicious_stew": "sumnjiva supa",
  "block.minecraft.loom": "radni sto za zastave",
  "item.minecraft.flower_banner_pattern": "oblik zastave□cvijet",
  "item.minecraft.creeper_banner_pattern": "oblik zastave□kriper",
  "item.minecraft.skull_banner_pattern": "oblik zastave□lobanja",
  "item.minecraft.mojang_banner_pattern": "oblik zastave□stvar",
  "item.minecraft.globe_banner_pattern": "oblik zastave□globus",
  "item.minecraft.piglin_banner_pattern": "oblik zastave□njuška",
  "block.minecraft.composter": "kompost",
  "block.minecraft.barrel": "bure",
  "block.minecraft.smoker": "pušač",
  "block.minecraft.blast_furnace": "visoka peć",
  "block.minecraft.cartography_table": "kartografski sto",
  "block.minecraft.fletching_table": "streljaški sto",
  "block.minecraft.grindstone": "mlinski kamen",
  "block.minecraft.lectern": "naslon za čitanje",
  "block.minecraft.smithing_table": "kovački sto",
  "block.minecraft.stonecutter": "kamenorezac",
  "block.minecraft.bell": "zvono",
  "block.minecraft.lantern": "fenjer",
  "block.minecraft.soul_lantern": "fenjer duše",
  "item.minecraft.sweet_berries": "slatke bobice",
  "block.minecraft.campfire": "logorska vatra",
  "block.minecraft.soul_campfire": "duševna logorska vatra",
  "block.minecraft.shroomlight": "gljivampa",
  "item.minecraft.honeycomb": "saće",
  "block.minecraft.bee_nest": "gnijezdo pčela",
  "block.minecraft.beehive": "košnica",
  "item.minecraft.honey_bottle": "bočica meda",
  "block.minecraft.honey_block": "blok meda",
  "block.minecraft.honeycomb_block": "blok saća",
  "block.minecraft.lodestone": "kamen vodič",
  "block.minecraft.netherite_block": "blok od nederita",
  "block.minecraft.ancient_debris": "drevni ostaci",
  "block.minecraft.target": "meta",
  "block.minecraft.crying_obsidian": "plačući obsidijan",
  "block.minecraft.blackstone": "crni kamen",
  "block.minecraft.blackstone_slab": "ploča od crnog kamena",
  "block.minecraft.blackstone_stairs": "stepenice od crnog kamena",
  "block.minecraft.gilded_blackstone": "pozlaćeni crni kamen",
  "block.minecraft.polished_blackstone": "polirani crni kamen",
  "block.minecraft.polished_blackstone_slab": "ploča od poliranog crnog kamena",
  "block.minecraft.polished_blackstone_stairs": "stepenice od poliranog crnog kamena",
  "block.minecraft.chiseled_polished_blackstone": "isklesani polirani crni kamen",
  "block.minecraft.polished_blackstone_bricks": "cigle poliranog crnog kamena",
  "block.minecraft.polished_blackstone_brick_slab": "ploča od cigli poliranog crnog kamena",
  "block.minecraft.polished_blackstone_brick_stairs": "stepenice od cigli poliranog crnog kamena",
  "block.minecraft.cracked_polished_blackstone_bricks": "napukle cigle poliranog crnog kamena",
  "block.minecraft.respawn_anchor": "sidro reinkarnacije",
}
export const bs_ba = items; 
